export type HiveRole =
  | 'SUPER_ADMIN'
  | 'AGENCY_EDITOR'
  | 'CLIENT_EDITOR'
  | 'CLIENT_VIEWER'
  | 'SCANNER_OPERATOR'
  | 'ATTENDEE';

export const HIVE_ROLES: ReadonlyArray<HiveRole> = [
  'SUPER_ADMIN',
  'AGENCY_EDITOR',
  'CLIENT_EDITOR',
  'CLIENT_VIEWER',
  'SCANNER_OPERATOR',
  'ATTENDEE',
];

const KNOWN_ROLES: ReadonlySet<string> = new Set<string>(HIVE_ROLES);

export function asHiveRole(value: unknown): HiveRole | null {
  if (typeof value !== 'string') {
    return null;
  }
  return KNOWN_ROLES.has(value) ? (value as HiveRole) : null;
}

export type Locale = 'nl' | 'en';

export const LOCALES: ReadonlyArray<Locale> = ['nl', 'en'];

export function asLocale(value: unknown): Locale | null {
  return value === 'nl' || value === 'en' ? value : null;
}
